var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (active, description, pages, title, undefined) {
buf.push("<div class=\"mpv-container\"><div class=\"mpv-sidebar\"><h1 class=\"mpv-title\">" + (jade.escape(null == (jade_interp = title) ? "" : jade_interp)) + "</h1><div class=\"mpv-description\">" + (null == (jade_interp = description) ? "" : jade_interp) + "</div><nav class=\"mpv-nav chevron-nav-list\">");
// iterate pages.models
;(function(){
  var $$obj = pages.models;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var page = $$obj[$index];

buf.push("<a" + (jade.attr("data-id", page.id, true, true)) + (jade.cls(['js-page',page.id === active.id ? 'is-active' : undefined], [null,true])) + ">" + (jade.escape(null == (jade_interp = page.get('title')) ? "" : jade_interp)) + "</a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var page = $$obj[$index];

buf.push("<a" + (jade.attr("data-id", page.id, true, true)) + (jade.cls(['js-page',page.id === active.id ? 'is-active' : undefined], [null,true])) + ">" + (jade.escape(null == (jade_interp = page.get('title')) ? "" : jade_interp)) + "</a>");
    }

  }
}).call(this);

buf.push("</nav></div><div class=\"mpv-page\"><div class=\"mpv-page-content\">" + (null == (jade_interp = active.mdToHtml('content')) ? "" : jade_interp) + "</div></div></div>");}.call(this,"active" in locals_for_with?locals_for_with.active:typeof active!=="undefined"?active:undefined,"description" in locals_for_with?locals_for_with.description:typeof description!=="undefined"?description:undefined,"pages" in locals_for_with?locals_for_with.pages:typeof pages!=="undefined"?pages:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;